// @ts-nocheck
import type { Question } from '../types';

export const motorwayRulesQuestions: Question[] = [
  {
    id: 'q-mr-1',
    topic: 'General',
    question: 'What is the minimum speed limit on a motorway in the Netherlands?',
    options: [
      { id: 'q-mr-1o1', text: '50 km/h' },
      { id: 'q-mr-1o2', text: '60 km/h' },
      { id: 'q-mr-1o3', text: '70 km/h' },
      { id: 'q-mr-1o4', text: '80 km/h' }
    ],
    answerId: 'q-mr-1o2',
    explanation: 'The minimum speed limit on a motorway in the Netherlands is 60 km/h. Vehicles that cannot maintain this speed are not allowed on motorways.',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-speed-limit.jpg',
    questionType: 'fillin',
    fillinAnswer: '60',
    fillinUnit: 'km/h',
  },
  {
    id: 'q-mr-2',
    topic: 'General',
    question: 'Which vehicles are not allowed on motorways?',
    options: [
      { id: 'q-mr-2o1', text: 'Motorcycles' },
      { id: 'q-mr-2o2', text: 'Mopeds and tractors' },
      { id: 'q-mr-2o3', text: 'Cars towing trailers' },
      { id: 'q-mr-2o4', text: 'All of the above' }
    ],
    answerId: 'q-mr-2o2',
    explanation: 'Mopeds and tractors are not allowed on motorways as they cannot maintain the minimum speed limit and would create a safety hazard.',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-prohibited-vehicles.jpg'
  },
  {
    id: 'q-mr-3',
    topic: 'General',
    question: 'What should you do if your vehicle breaks down on a motorway?',
    options: [
      { id: 'q-mr-3o1', text: 'Stay in your vehicle' },
      { id: 'q-mr-3o2', text: 'Get out and stand behind the barrier' },
      { id: 'q-mr-3o3', text: 'Walk along the motorway to find help' },
      { id: 'q-mr-3o4', text: 'Try to repair the vehicle yourself' }
    ],
    answerId: 'q-mr-3o2',
    explanation: 'If your vehicle breaks down on a motorway, you should get out of your vehicle and stand behind the safety barrier. Call for assistance using the emergency phones.',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-breakdown.jpg'
  },
  {
    id: 'q-mr-4',
    topic: 'General',
    question: 'What is the purpose of the hard shoulder on a motorway?',
    options: [
      { id: 'q-mr-4o1', text: 'For overtaking slow vehicles' },
      { id: 'q-mr-4o2', text: 'For emergency stops and breakdowns' },
      { id: 'q-mr-4o3', text: 'For parking when tired' },
      { id: 'q-mr-4o4', text: 'For making phone calls' }
    ],
    answerId: 'q-mr-4o2',
    explanation: 'The hard shoulder is reserved for emergency stops and breakdowns only. It should not be used for normal driving, overtaking, or parking.',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-hard-shoulder.jpg'
  },
  {
    id: 'q-mr-5',
    topic: 'General',
    question: 'What should you do when approaching a motorway exit?',
    options: [
      { id: 'q-mr-5o1', text: 'Speed up to get through quickly' },
      { id: 'q-mr-5o2', text: 'Move to the left lane early' },
      { id: 'q-mr-5o3', text: 'Move to the right lane early' },
      { id: 'q-mr-5o4', text: 'Honk your horn to signal your intention' }
    ],
    answerId: 'q-mr-5o3',
    explanation: 'When approaching a motorway exit, you should move to the right lane early and reduce your speed gradually to safely exit the motorway.',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-route-signage.jpg'
  },
  {
    id: 'q-mr-6',
    topic: 'General',
    question: 'You are on a motorway on-ramp and see a Give Way sign before the merge point. What must you do?',
    options: [
      { id: 'q-mr-6o1', text: 'You have priority — accelerate and merge immediately' },
      { id: 'q-mr-6o2', text: 'Give way to motorway traffic, then accelerate to match their speed and merge safely' },
      { id: 'q-mr-6o3', text: 'Stop completely and wait for the motorway to be empty' },
      { id: 'q-mr-6o4', text: 'Use your horn to signal your intention to merge' }
    ],
    answerId: 'q-mr-6o2',
    explanation: 'On a motorway on-ramp, you must give way to vehicles already on the motorway (RVV 1990 art. 43). Use the on-ramp to build up speed, yield if necessary, then merge smoothly into a safe gap.',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-onramp-yield.jpg'
  },
  {
    id: 'q-mr-7',
    topic: 'General',
    question: 'What does a variable speed limit sign on a motorway mean?',
    options: [
      { id: 'q-mr-7o1', text: 'The speed limit is optional' },
      { id: 'q-mr-7o2', text: 'You must follow the displayed speed limit' },
      { id: 'q-mr-7o3', text: 'The speed limit only applies to trucks' },
      { id: 'q-mr-7o4', text: 'The speed limit only applies at night' }
    ],
    answerId: 'q-mr-7o2',
    explanation: 'Variable speed limit signs on motorways display mandatory speed limits that you must follow. These are used to manage traffic flow and improve safety. (RVV 1990 art. 82)',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-gantry-lane-closed.jpg'
  },
  {
    id: 'q-mr-8',
    topic: 'General',
    question: 'What should you do if you miss your motorway exit?',
    options: [
      { id: 'q-mr-8o1', text: 'Reverse back to the exit' },
      { id: 'q-mr-8o2', text: 'Stop and turn around' },
      { id: 'q-mr-8o3', text: 'Continue to the next exit' },
      { id: 'q-mr-8o4', text: 'Use the hard shoulder to turn around' }
    ],
    answerId: 'q-mr-8o3',
    explanation: 'If you miss your motorway exit, you should continue to the next exit and find an alternative route. Never reverse, stop, or turn around on a motorway.',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-exit-approach.jpg'
  },
  {
    id: 'q-mr-9',
    topic: 'General',
    question: 'What is the purpose of lane markings on a motorway?',
    options: [
      { id: 'q-mr-9o1', text: 'To separate different types of vehicles' },
      { id: 'q-mr-9o2', text: 'To organize traffic flow and prevent accidents' },
      { id: 'q-mr-9o3', text: 'To create parking spaces' },
      { id: 'q-mr-9o4', text: 'To mark emergency stopping areas' }
    ],
    answerId: 'q-mr-9o2',
    explanation: 'Lane markings on motorways help organize traffic flow, prevent accidents, and ensure safe driving by clearly defining where vehicles should drive.',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-chevrons.jpg'
  },
  {
    id: 'q-mr-10',
    topic: 'General',
    question: 'What should you do when overtaking on a motorway?',
    options: [
      { id: 'q-mr-10o1', text: 'Use the hard shoulder' },
      { id: 'q-mr-10o2', text: 'Use the left lane' },
      { id: 'q-mr-10o3', text: 'Use the right lane' },
      { id: 'q-mr-10o4', text: 'Honk your horn continuously' }
    ],
    answerId: 'q-mr-10o2',
    explanation: 'When overtaking on a motorway, you should use the left lane (the lane to the left of the vehicle you are overtaking). (RVV 1990 art. 40)',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-lane-discipline.jpg'
  },
  {
    id: 'q-mr-11',
    topic: 'General',
    question: 'You are following a heavy goods vehicle on a motorway. What is the most important thing to maintain?',
    options: [
      { id: 'q-mr-11o1', text: 'A large safe following distance, as trucks need more stopping distance' },
      { id: 'q-mr-11o2', text: 'Close proximity so you can see past the truck' },
      { id: 'q-mr-11o3', text: 'The same speed as the truck at all times' },
      { id: 'q-mr-11o4', text: 'The left lane position ready to overtake immediately' }
    ],
    answerId: 'q-mr-11o1',
    explanation: 'When following a heavy goods vehicle on a motorway, you must maintain a large safe following distance. Trucks have longer braking distances, create wind turbulence, and block your forward view. Keep well back so you can react in time. (RVV 1990 art. 19)',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-following-truck.jpg'
  },
  {
    id: 'q-mr-12',
    topic: 'General',
    question: 'What should you do if you see an emergency vehicle on a motorway?',
    options: [
      { id: 'q-mr-12o1', text: 'Ignore it and continue driving' },
      { id: 'q-mr-12o2', text: 'Move to the right and slow down' },
      { id: 'q-mr-12o3', text: 'Speed up to get out of the way' },
      { id: 'q-mr-12o4', text: 'Stop immediately' }
    ],
    answerId: 'q-mr-12o2',
    explanation: 'If you see an emergency vehicle on a motorway, you should move to the right lane and slow down to allow it to pass safely.',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-emergency-response.jpg'
  },
  {
    id: 'q-mr-13',
    topic: 'General',
    question: 'When you see emergency vehicles approaching on a motorway with flashing lights, what should you do?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-emergency-corridor.jpg',
    options: [
      { id: 'q-mr-13o1', text: 'Stay in your lane and let them pass' },
      { id: 'q-mr-13o2', text: 'Create an emergency corridor by moving to the left/right and slow down' },
      { id: 'q-mr-13o3', text: 'Speed up to clear the road' }
    ],
    answerId: 'q-mr-13o2',
    explanation: 'When emergency vehicles approach with flashing lights, you must create an emergency corridor (noodhulpstrook) by moving to the left or right and slowing down to allow safe passage. (RVV 1990 art. 3)',
    subject: 'Motorway Rules'
  },
  {
    id: 'q-mr-14',
    topic: 'General',
    question: 'What is the recommended minimum safe following distance at 100 km/h on a motorway?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/q-mr-14-following-distance.jpg',
    options: [
      { id: 'q-mr-14o1', text: '30 meters' },
      { id: 'q-mr-14o2', text: '60 meters' },
      { id: 'q-mr-14o3', text: '100 meters' }
    ],
    answerId: 'q-mr-14o2',
    explanation: 'At 100 km/h, the recommended minimum safe following distance is 60 meters. This gives you enough time to react and brake safely if the vehicle ahead stops suddenly. Keeping too close is one of the main causes of motorway accidents. (RVV 1990 art. 19)',
    subject: 'Motorway Rules'
  },
  {
    id: 'q-mr-15',
    topic: 'General',
    question: 'On a motorway with multiple lanes, which lane should you normally drive in?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/q-mr-15-lane-discipline.jpg',
    options: [
      { id: 'q-mr-15o1', text: 'The right lane' },
      { id: 'q-mr-15o2', text: 'The left lane' },
      { id: 'q-mr-15o3', text: 'The middle lane' }
    ],
    answerId: 'q-mr-15o1',
    explanation: 'You should normally drive in the right lane and only use the left lanes for overtaking. After overtaking, return to the right lane. This is the "houden rechts" (keep right) rule. (RVV 1990 art. 40)',
    subject: 'Motorway Rules'
  },
  {
    id: 'q-mr-16',
    topic: 'General',
    question: 'When merging onto a motorway, what must you check before changing lanes?',
    options: [
      { id: 'q-mr-16o1', text: 'Mirrors only' },
      { id: 'q-mr-16o2', text: 'Mirrors and your blind spot over your shoulder' },
      { id: 'q-mr-16o3', text: 'Speed of traffic only' }
    ],
    answerId: 'q-mr-16o2',
    explanation: 'Before changing lanes when merging, you must check both mirrors and your blind spot over your shoulder to ensure no vehicles are in your intended path. (RVV 1990 art. 45)',
    subject: 'Motorway Rules',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/motorway-overtaking.jpg'
  },
  {
    id: 'q-mr-17',
    topic: 'General',
    question: 'What should you do when driving on a wet motorway with reduced grip?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/motorway-rules/q-mr-17-wet-motorway.jpg',
    options: [
      { id: 'q-mr-17o1', text: 'Maintain speed and use hazard lights' },
      { id: 'q-mr-17o2', text: 'Reduce speed significantly and increase following distance' },
      { id: 'q-mr-17o3', text: 'Exit the motorway immediately' }
    ],
    answerId: 'q-mr-17o2',
    explanation: 'On wet motorways with reduced traction, you must reduce speed significantly and increase your following distance. Wet road conditions increase stopping distance and reduce grip. (RVV 1990 art. 10)',
    subject: 'Motorway Rules'
  },
];
